import { FOOTER_CONTENT } from "../constants"
import { useTranslation } from "react-i18next";
import { trackEvent } from "../analytics/googleAnalytics";

const FOOTER_LINK_DESTINATIONS = {
  "https://www.linkedin.com/company/sepm-software-engineering-and-project-management": "linkedin",
  "https://sepmworldwide.zendesk.com/": "sepm_support",
};

const Footer = () => {
    const { t } = useTranslation();

    const handleExternalLinkClick = (url) => {
        const destination = FOOTER_LINK_DESTINATIONS[url];
        if (!destination) {
            return;
        }
        trackEvent("external_link_clicked", {
            destination,
            location: "footer",
        });
    };

    return (
        <footer id="footer" className="mt-20 text-neutral-400">
            <div className="max-w-7xl mx-auto px-4 border-t border-neutral-800">
                <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mt-20">

                    <div>
                        <div className="text-neutral-600 font-medium mb-4">{t('footer.contactUsText')}</div>
                        {t('footer.contactUsDesc').split("\n").map((text, index) => (
                            <span className="text-StandardSEPM font-medium" key={index}>
                                {text}
                                <br />
                            </span>
                        ))}

                    </div>

                    {FOOTER_CONTENT.sections.map((section, index) => (
                        <div key={index}>
                            <h3 className="text-neutral-600 font-medium mb-4">{t(`footer.sections.${index}.title`)}</h3>
                            <ul className="space-y-2 text-StandardSEPM">
                                {section.links.map((link, linkIndex) => (
                                    <li key={linkIndex}>
                                        <a
                                            className="hover:font-semibold"
                                            href={link.url}
                                            target="_blank"
                                            rel="noreferrer"
                                            onClick={() => handleExternalLinkClick(link.url)}
                                        >
                                            {t(`footer.sections.${index}.links.${linkIndex}.text`)}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="my-12 border-t border-neutral-800 pt-8 text-center text-sm text-neutral-500">
                    <div className="flex justify-between">
                        <div className="text-xs">
                            <p>{t('footer.platformsText')}</p>
                        </div>
                        <div className="text-xs">
                            <p>{t('footer.copyrightText')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
